import React, { Component } from 'react'
// Component = React.Component
import LoanCalculator from './components/LoanCalculator';
import CreditCardCalculator from './components/CreditCardCalculator2';
import Locales from './utils/locales.json'
export default class Calculators extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeCard: 'LoanCalculator'
    }
    this.toggleCard = this.toggleCard.bind(this)
    this.multipleCalculators = this.multipleCalculators.bind(this)
    this.btCalendar = this.btCalendar.bind(this)
    this.locale = window.location.pathname.match(/\/en\-hk/) ? 'en' : window.location.pathname.match(/\/zh\-cn/) ? 'cn' : 'tc'
  }
  toggleCard(){
    this.setState({
      activeCard: this.state.activeCard == 'LoanCalculator' ? 'CreditCardCalculator' : 'LoanCalculator'
    })
  }
  multipleCalculators(){
    let translations = Locales[this.locale]
    return (
      <div className='calculators'>
        <LoanCalculator
          active={this.state.activeCard == 'LoanCalculator'}
          translations={translations}
        />
        <CreditCardCalculator
          active={this.state.activeCard == 'CreditCardCalculator'}
          translations={translations}
        />
        <div className="selector" onClick={this.toggleCard}>
          {translations[anotherCard].name}
        </div>
      </div>
    )
  }
  btCalendar(){
    return (
      <div className='calculators'>
      <CreditCardCalculator
        active={this.state.activeCard == 'CreditCardCalculator'}
        translations={Locales[this.locale]}
      />
      </div>
    )
  }
  render() {
    let anotherCard = 'LoanCalculator';
    if (this.state.activeCard == 'LoanCalculator')
      anotherCard = 'CreditCardCalculator'
    let translations = Locales[this.locale]
    return (
      <CreditCardCalculator
        active={this.state.activeCard == 'CreditCardCalculator'}
        translations={Locales[this.locale]}
      />
    )
  }
}

